import React from 'react'
import { hasData } from '../../repositories/BoardsRepository'
import { loadBoards, createBoard } from '../../flux/boards/BoardActions'
import StorageUnavailableModalComponent from './StorageUnavailableModal'
import StorageEmptyModalComponent from './StorageEmptyModal'
import SettingsStore from '../../flux/settings/SettingsStore'

/**
 * Component loads boards from the repository.
 * Handles states where repository is unavailable or no data is present.
 */
function ControlLoadComponent() {
    const settingsStore = SettingsStore.GetInstance()

    /**
     * Handles user requesting load of evaluation data
     */
    function loadEvalData() {
        loadBoards(true)
    }

    /**
     * Handles the user wanting to start fresh.
     * loads existing data and invokes "createBoard"
     * so they start with the form open.
     */
    function startFresh() {
        loadBoards(false)
        createBoard()
    }

    /**
     * Determines if the storage unavailable modal gets rendered or not
     */
    function getStorageUnavailable() {
        return settingsStore.CanUseLocalStorage ? (
            <></>
        ) : (
            <StorageUnavailableModalComponent onOk={loadEvalData} />
        )
    }

    /**
     * Determines if the user is presented the option to start fresh
     * or load the evaluation data.
     */
    function getStorageEmpty() {
        // no storage? just return
        if (!settingsStore.CanUseLocalStorage) return <></>
        // has data? just return
        if (hasData()) return <></>
        // show empty modal
        return (
            <StorageEmptyModalComponent
                onLoadTestData={loadEvalData}
                onStartFresh={startFresh}
            />
        )
    }

    if (settingsStore.CanUseLocalStorage && hasData()) loadBoards(false)

    return (
        <>
            {getStorageUnavailable()}
            {getStorageEmpty()}
        </>
    )
}

export default ControlLoadComponent
